<template>
    <div STYLE="text-align: center; font-size: 30px; font-weight: bold; padding: 20px">
        このサイトでは Cookie を使用しています。 ご利用を継続するにはCookie を有効にしてください。
    </div>
</template>

<script>
    export default {
        name: "CookieRequired",
    }
</script>

<style scoped>
</style>